var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.objectIsEmpty
    ? _c(
        "div",
        { staticClass: "store-card" },
        [
          _c("vue-client-only", [
            _vm.adaptive.isDesktop
              ? _c("span", [_vm._v("\n      Адрес\n    ")])
              : _vm._e()
          ]),
          _c(
            "div",
            { staticClass: "metro" },
            _vm._l(_vm.store.metro, function(metro) {
              return _c("div", { key: metro.id }, [
                _c("span", { style: { backgroundColor: metro.line.color } }),
                _vm._v(_vm._s(metro.name) + "\n    ")
              ])
            }),
            0
          ),
          _c("div", { staticClass: "address" }, [
            _vm._v("\n    " + _vm._s(_vm.store.address) + "\n  ")
          ]),
          !_vm.cartButton
            ? _c("div", { staticClass: "phone" }, [
                _c("span", [_vm._v("Телефон:")]),
                _vm._v(
                  " " +
                    _vm._s(_vm._f("noBracesPhone")(_vm.store.phone)) +
                    "\n  "
                )
              ])
            : _vm._e(),
          _c("div", { staticClass: "format" }, [
            _c("span", [_vm._v("Формат:")]),
            _vm._v(" " + _vm._s(_vm.store.workMode || "") + "\n  ")
          ]),
          _c(
            "div",
            { staticClass: "bottom" },
            [
              _vm.closestDate
                ? _c(
                    "div",
                    { staticClass: "date" },
                    [
                      _c("vue-client-only", [
                        _vm.adaptive.isDesktop
                          ? _c("span", [
                              _vm._v("\n          Можно забрать\n        ")
                            ])
                          : _vm._e()
                      ]),
                      _vm._v("\n      " + _vm._s(_vm.closestDate) + "\n    ")
                    ],
                    1
                  )
                : _c("div", { staticClass: "schedule" }, [
                    _vm.store.workSchedule.length
                      ? _c("span", [_vm._v("\n        Часы работы:\n      ")])
                      : _vm._e(),
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm._f("parseWorkSchedule")(_vm.store)) +
                        "\n    "
                    )
                  ]),
              _vm.cartButton
                ? _c("to-cart", {
                    staticClass: "pickup-button",
                    attrs: {
                      product: _vm.PRODUCT,
                      "sku-id": _vm.ACTIVE_SKU.id,
                      "hide-icons": "",
                      "hide-notification": "",
                      "store-id": _vm.store.id,
                      "text-add": "Забрать из магазина"
                    },
                    on: { add: _vm.onAddToCart }
                  })
                : _vm._e(),
              _c("vue-client-only", [
                _vm.adaptive.isDesktop
                  ? _c(
                      "div",
                      {
                        staticClass: "close-button",
                        on: {
                          click: function($event) {
                            return _vm.$emit("close")
                          }
                        }
                      },
                      [
                        _c("f-sprite-icon", {
                          attrs: {
                            "icon-link": _vm.$options.icons.IconClose.id
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }